"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sesto-al-reghena": {
    "54733756": [{
      "hkey": "e6e8e5e6",
      "slug": "bagnarola-vissignano",
      "name": "Bagnarola-Vissignano",
      "primary": true,
      "skipSearch": false
    }],
    "bagnarola": [{
      "hkey": "e6e8e5e6",
      "slug": "bagnarola-vissignano",
      "name": "Bagnarola-Vissignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e2879e58": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "banduzzo": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77d78a1b": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-di-sotto": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c4116d8f": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-magredo": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b819fd28": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-sacile": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6aa01038": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "braida": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26093145": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "braidacurti": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e93d37f5": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "fratticelle": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "058d41fa": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "venchieredo": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bee85222": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "skipSearch": false
    }],
    "versiola": [{
      "hkey": "34c10b1a",
      "slug": "sesto-al-reghena",
      "name": "Sesto al Reghena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9515a046": [{
      "hkey": "e6e8e5e6",
      "slug": "bagnarola-vissignano",
      "name": "Bagnarola-Vissignano",
      "primary": true,
      "skipSearch": false
    }],
    "vissignano": [{
      "hkey": "e6e8e5e6",
      "slug": "bagnarola-vissignano",
      "name": "Bagnarola-Vissignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sesto-al-reghena"
    }]
  }
};
exports["default"] = _default;